export default __webpack_public_path__ + "static/media/283.dd19b741.jpg";